module.exports = __webpack_public_path__ + "img/n-5.0c785352.png";